import React, { useEffect, useState } from 'react';

interface IClearProps {
	canClear: boolean,
	clear: (ciq?: object) => void,
	ciq?: object,
}

export const Clear: React.FunctionComponent<IClearProps> = ({ ciq, canClear, clear}) => {
	const [cName, setCName] = useState('ciq-btn')

	useEffect(() => {
		setCName(canClear ? 'ciq-btn active' : 'ciq-btn')
	}, [canClear])

	const clearButtonClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
		clear(ciq);
	}

	return (
		<button disabled={!canClear} className={cName} onClick={clearButtonClickHandler}>Clear</button>
	);
};